import React from "react";
import { Dropdown } from "@carbon/react";
import { useTranslation } from "react-i18next";

export default function HeatmapCameraSelector({
  options = [],
  value,
  disabled,
  onChange,
}) {
  const { t } = useTranslation();
  if (!options?.length) return null;

  const safeValue = options.includes(value) ? value : options[0];

  return (
    <div className="heatmap-camera-selector mm-dropdown">
      <Dropdown
        id="heatmap-camera-selector"
        titleText={t("heatmap.camera")}
        label={safeValue || t("heatmap.allCameras")}
        items={options}
        selectedItem={safeValue}
        itemToString={(item) => item || ""}
        disabled={disabled}
        onChange={({ selectedItem }) => onChange?.(selectedItem || null)}
      />
    </div>
  );
}
